import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconDirectionsBike = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconDirectionsBike",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M620-740q-33 0-56-23t-24-57 24-56 56-24 57 24 23 56-23 57-57 23M432-540l66 69q11 11 17 25t5 30v176q0 17-11 29t-29 11-28-11-12-29v-160L312-512q-14-12-19-25t-5-31 6-30 18-26l112-112q13-13 28-18t32-6 33 6 27 18l76 76q21 21 47 36t58 20q17 3 28 15t11 29-12 28-29 9q-49-7-90-28t-73-53l-32-32zm-232 60q85 0 143 58t57 142-57 143-143 57-142-57T0-280t58-142 142-58m0 340q57 0 99-41t41-99-41-98-99-42-98 42-42 98 42 99 98 41m560-340q85 0 143 58t57 142-57 143-143 57-142-57-58-143 58-142 142-58m0 340q57 0 99-41t41-99-41-98-99-42-98 42-42 98 42 99 98 41"
  })
}));
IconDirectionsBike.displayName = 'IconDirectionsBike';